import { gql } from '@/__generated__';

const SEND_DATA_MUTATION = gql(`#graphql
  mutation CreateRegisMeasurement($input: CreateRegisMeasurementInput!) {
    createRegisMeasurement(input: $input) {
      regis {
        id
      }
    }
  }
`);

export default SEND_DATA_MUTATION;
